// extracted by mini-css-extract-plugin
module.exports = {"Model":"Modal_Model__1nTfu"};